import React from "react";
import classes from "./AIStarButton.scss";
import { StarsTwoFilled, AiOutlined } from "@toddle-edu/ds-icons";
import { IconButton } from "@toddle-edu/ds-web";

const CustomIcon = () => {
  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      <StarsTwoFilled variant={"link"} size={"xxx-small"} />
      <AiOutlined size="x-small" variant="link" />
    </div>
  );
};
const AIStarButton = props => {
  return (
    <IconButton
      {...props}
      icon={<CustomIcon />}
      variant="plain"
      className={classes.aiIconButton}
    />
  );
};

export default AIStarButton;
